// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + {"18":"232eff7f42b3cab25470","337":"829dea8fb45b14070982","599":"d6bc738c7a85a7a2c606","709":"8c42421eee6dc68a036e","847":"fbabd7578052acb7f54b","973":"ed60f98d43b1bb89ab46"}[chunkId] + ".js";
};